import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SendIcon from './icons/SendIcon';
import EmojiIcon from './icons/EmojiIcon';
import FileIcon from './icons/FileIcon';

// import EmojiPicker from './emoji-picker/EmojiPicker';
// import { ImageFormAPI } from '../../../../API/GenericAPI';
// import { ImageFormAPI } from '../../../../API/GenericAPI';
// import API from '../../../../API/GenericAPI';

class UserInput extends Component {
  constructor() {
    super();
    this.state = {
      inputActive: false,
    };
  }

  handleKey(event) {
    if (event.keyCode === 13 && !event.shiftKey) {
      this._submitText(event);
    }
  }

  _showFilePicker() {
    this._fileUploadButton.click();
  }

  _submitText(event) {
    event.preventDefault();
    const text = this.userInput.textContent;
    if (text && text.length > 0) {
      this.props.onSubmit({
        sender: localStorage.getItem('__providerId__'),
        type: 'text',
        message: text,
      });
      this.userInput.innerHTML = '';
    }
  }
  _uploadImage = (urlObj, type) => {
    this.props.onSubmit({
      sender: localStorage.getItem('__providerId__'),
      type: type,
      message: urlObj.url,
      tempUrl: urlObj.accessUrl,
    });
  };

  _handleEmojiPicked(emoji) {
    this.props.onSubmit({
      sender: localStorage.getItem('__providerId__'),
      type: 'text',
      message: emoji,
    });
  }

  render() {
    return (
      <form className={`sc-user-input ${this.state.inputActive ? 'active' : ''}`}>
        <div
          role="button"
          tabIndex="0"
          onFocus={() => {
            this.setState({ inputActive: true });
          }}
          onBlur={() => {
            this.setState({ inputActive: false });
          }}
          ref={e => {
            this.userInput = e;
          }}
          onKeyDown={this.handleKey.bind(this)}
          contentEditable="true"
          placeholder="Write a reply..."
          className="sc-user-input--text"
        />
        <div className="sc-user-input--buttons">
          <div className="sc-user-input--button">
            <EmojiIcon onEmojiPicked={this._handleEmojiPicked.bind(this)} />
          </div>
          <div className="sc-user-input--button">
            <FileIcon onClick={this._showFilePicker.bind(this)} />
            <input
              type="file"
              id="upload"
              accept=".png,.gif,.jpg,.pdf"
              multiple
              ref={e => {
                this._fileUploadButton = e;
              }}
            />
          </div>
          <div className="sc-user-input--button">
            <SendIcon onFocus={this.state.inputActive} onClick={this._submitText.bind(this)} />
          </div>
        </div>
      </form>
    );
  }
}

UserInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default UserInput;
